import type { ICellRendererComp, ICellRendererParams, ColDef } from "ag-grid-enterprise";
import { buildMaskedSpan } from "../masked_cell";

// Presentation only: sort, filter and search still see the real value.
export class MaskedTextCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams): void {
    const field = (params.colDef as ColDef)?.field ?? "value";
    const text = params.value == null ? "" : String(params.value);
    this.eGui = buildMaskedSpan(text, params, field);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }
}
